// Servicio de IA - usa una Edge Function como proxy para proteger las claves
import { callFunction } from './backendService';

export const suggestRecipeByIngredients = async (ingredients) => {
  try {
    return await callFunction('generate-recipe', { ingredients });
  } catch (error) {
    console.error('Error calling AI service:', error);
    throw new Error('Error al generar la receta con IA');
  }
};

export const speakInstruction = async (text) => {
  // Usar la Web Speech API del navegador (gratuita)
  if ('speechSynthesis' in window) {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'es-ES';
    utterance.rate = 0.9;
    utterance.pitch = 1;
    
    // Buscar una voz en español
    const voices = window.speechSynthesis.getVoices();
    const spanishVoice = voices.find(voice => voice.lang.startsWith('es'));
    if (spanishVoice) {
      utterance.voice = spanishVoice;
    }
    
    window.speechSynthesis.speak(utterance);
  } else {
    console.warn('Text-to-speech not supported in this browser');
  }
};
